export default {
  namespaced: true,
  state: {
    currentPage: null,
  },
  mutations: {
    setCurrentPage(state, page) {
      state.currentPage = page;
    },
  },
  actions: {
    loadPage({ commit }, id) {
      return import(`../../lang/pages/${id}.yml`)
        .then((page) => {
          commit('setCurrentPage', page.default);
          return page.default;
        });
    },
  },
};
